import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";
import TextareaAutosize from 'react-textarea-autosize';
import {func} from "prop-types";
function MultilineStringInput(props) {

    const {disable} = React.useContext(ChangeCheckContext)
    const { onChange, getStyle } = useChangeCheck(props.onChange);

    function customStyle() {
        let style = getStyle() || {}
        style.width = "100%"
        return style
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className="mb-3">
                <TextareaAutosize disabled={disable} name={props.name} onChange={onChange} value={props.value}
                              style={customStyle()}/>
            </InputGroup>
        </>
    )
}

export default MultilineStringInput
